(() => {
  function initProductPage() {
    const root = document.querySelector('.pc-pdp');
    if (!root) return;

    const capsuleButtons = [...root.querySelectorAll('.pc-capsule')];
    const rows = [...root.querySelectorAll('.pc-pdp__offer')];
    const form = document.getElementById('pcDirectCheckout');
    const variantInput = form?.querySelector('[data-pc-form-variant]');
    const quantityInput = form?.querySelector('[data-pc-form-quantity]');
    const sticky = document.getElementById('pcStickyBar');
    const stickyBadge = document.getElementById('pcStickyBadge');
    const stickyCta = document.getElementById('pcStickyCta');
    const mainImage = document.getElementById('pcPdpMain');
    let selectedCapsule = capsuleButtons.find((button) => button.classList.contains('is-selected')) || capsuleButtons[0];
    let selectedRow = rows[0];

    function rowValue(button, index) {
      if (index === 0) return button.dataset.priceOne;
      if (index === 1) return button.dataset.priceThree;
      return button.dataset.priceFive;
    }

    function regularValue(button, index) {
      if (index === 1) return button.dataset.regularThree;
      if (index === 2) return button.dataset.regularFive;
      return '';
    }

    function syncCheckout() {
      if (!selectedCapsule || !selectedRow) return;
      const bottles = Number(selectedRow.dataset.bottles || 1);
      const total = rowValue(selectedCapsule, Number(selectedRow.dataset.index || 0));
      if (variantInput) variantInput.value = selectedCapsule.dataset.variant;
      if (quantityInput) quantityInput.value = String(bottles);
      if (stickyBadge) {
        stickyBadge.textContent = `${selectedCapsule.dataset.capsules} · ${bottles} ${bottles === 1 ? 'bottle' : 'bottles'}`;
      }
      if (stickyCta) stickyCta.textContent = `Get Now · ${total} total`;
    }

    function selectRow(row) {
      selectedRow = row;
      rows.forEach((item) => {
        const active = item === row;
        item.classList.toggle('is-selected', active);
        const input = item.querySelector('input[type="radio"]');
        if (input) input.checked = active;
      });
      syncCheckout();
    }

    function renderCapsule(button) {
      selectedCapsule = button;
      capsuleButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      const capsuleTag = document.getElementById('pcCapsuleTag');
      if (capsuleTag) capsuleTag.textContent = `${button.dataset.capsules} selected`;

      rows.forEach((row, index) => {
        const price = row.querySelector('[data-row-price]');
        const regular = row.querySelector('[data-row-regular]');
        const badge = row.querySelector('[data-row-badge]');
        if (price) price.textContent = rowValue(button, index);
        if (regular) regular.textContent = regularValue(button, index);
        if (badge && index === 1) badge.textContent = button.dataset.saveThree;
      });

      if (mainImage && button.dataset.image) {
        const nextImage = new URL(button.dataset.image, window.location.href).href;
        if (mainImage.src !== nextImage) mainImage.src = nextImage;
        mainImage.dataset.kind = 'bottle';
        root.querySelectorAll('.pc-pdp__thumb').forEach((thumb) => thumb.classList.remove('is-active'));
      }

      selectRow(rows[0]);
    }

    capsuleButtons.forEach((button) => button.addEventListener('click', () => renderCapsule(button)));
    rows.forEach((row) => row.addEventListener('click', () => selectRow(row)));

    root.querySelectorAll('.pc-pdp__thumb').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('.pc-pdp__thumb').forEach((thumb) => thumb.classList.remove('is-active'));
        button.classList.add('is-active');
        if (!mainImage) return;
        mainImage.src = button.dataset.src;
        mainImage.alt = button.dataset.alt || '';
        mainImage.dataset.kind = button.dataset.kind || 'bottle';
      });
    });

    stickyCta?.addEventListener('click', () => form?.requestSubmit());

    function syncSticky() {
      if (!sticky || !stickyCta || !form) return;
      const submitButton = document.getElementById('pcPdpCta');
      const show = submitButton && submitButton.getBoundingClientRect().bottom < 0;
      if (show) {
        sticky.removeAttribute('data-hidden');
        sticky.setAttribute('aria-hidden', 'false');
        stickyCta.removeAttribute('tabindex');
      } else {
        sticky.setAttribute('data-hidden', '');
        sticky.setAttribute('aria-hidden', 'true');
        stickyCta.setAttribute('tabindex', '-1');
      }
    }

    addEventListener('scroll', syncSticky, { passive: true });
    addEventListener('resize', syncSticky, { passive: true });

    const ratingDesktop = root.querySelector('[data-pc-rating-desktop]');
    const ratingMobile = root.querySelector('[data-pc-rating-mobile]');
    let ratingResolved = false;

    function syncTrustooRating() {
      const widget = document.querySelector('#trustoo-widget-wrapper, #reviews-wrapper');
      const widgetText = widget?.textContent || '';
      const scoreMatch = widgetText.match(/\b([0-5](?:\.\d)?)\s+(\d+)\s+reviews?\b/i);
      const insertedRating = [...document.querySelectorAll('.product-icon-list.vstar-star')]
        .find((node) => !node.closest('#reviews') && !node.closest('#pcTrustooRating'));
      const countMatch = (insertedRating?.textContent || '').match(/(\d+)\s+reviews?/i);
      const score = scoreMatch?.[1];
      const count = scoreMatch?.[2] || countMatch?.[1];

      if (count) {
        const desktopText = `${count} Reviews`;
        const mobileText = score ? `${score}/5 from ${count} reviews` : `${count} verified reviews`;
        if (ratingDesktop && ratingDesktop.textContent !== desktopText) ratingDesktop.textContent = desktopText;
        if (ratingMobile && ratingMobile.textContent !== mobileText) ratingMobile.textContent = mobileText;
        ratingResolved = true;
      }

      if (insertedRating) {
        insertedRating.setAttribute('aria-hidden', 'true');
        insertedRating.style.display = 'none';
      }
    }

    function hideProductSubscriptionWidgets() {
      document.querySelectorAll('[id*="appstle" i], [class*="appstle" i]').forEach((node) => {
        if (node instanceof HTMLElement) {
          node.hidden = true;
          node.style.setProperty('display', 'none', 'important');
        }
      });
    }

    syncTrustooRating();
    hideProductSubscriptionWidgets();
    const observer = new MutationObserver(() => {
      syncTrustooRating();
      hideProductSubscriptionWidgets();
      if (ratingResolved && document.querySelector('#trustoo-widget-wrapper')) {
        setTimeout(() => observer.disconnect(), 1000);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 20000);

    renderCapsule(selectedCapsule);
    syncSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage, { once: true });
  } else {
    initProductPage();
  }
})();
